import { useState, useEffect, useRef } from "react"
import { Flex, Input, Modal, Form, Dropdown, List, Button } from "antd"
import { useTranslation } from "react-i18next"
import { getStrayCards, connectCard } from "../../../../api/Cards"
import { useUser } from "../../../../contexts/UserContext"
import "./NewCardModal.css"
import { BrowserView, MobileView } from 'react-device-detect';
import QRScanner2 from "./QRScanner2"

const NewCardModal = ({onClose, selectedUser}) => {

    const handleCancel = () => onClose();
    const { t } = useTranslation()
    const { user, getToken } = useUser()
    const [cards, setCards] = useState([])
    const [selectedCard, setSelectedCard] = useState("")
    const [cardFilter, setCardFilter] = useState("")

    const [data, setData] = useState();

    const [qrdata, setQRData] = useState("No result");
    const [showQRScanner, setShowQRScanner] = useState(false)

    useEffect(() => {

        async function getCards() {
            const data = await getStrayCards(user.token)

            if (typeof data === "number") {
                return;
            }

            console.log(data)
            setCards(data)
        }

        getCards();

    }, [])

    function base64ToBase16(base64) {
        return window.atob(base64)

            .split('')
            .map(function (aChar) {
                return ('0' + aChar.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
            .toUpperCase().substring(0, 24);
    }

    function getStyle(cardId) {
        if (cardId == selectedCard) {
            return {color: "lightblue", borderColor: "lightblue", borderWidth:"2px", borderStyle:"solid", borderRadius:"4px", padding:"13px"}
        }
        return {}
    }

    function getItems() {
        return cards
            .filter((item) => { return (!cardFilter || base64ToBase16(item.CardId).includes(cardFilter)) } )
            .map(({ CardId }, i) => (<List.Item style={{ borderBlockEnd: "none" }} onClick={() => { setSelectedCard(CardId) }} key={i}><p className="alist-item" style={getStyle(CardId)}>{base64ToBase16(CardId)}</p></List.Item>))
    }

    function connectSelectedCard() {
        async function connectUserToCard() {
            const data = await connectCard({ Token: user.token, CardID: selectedCard, UserID: selectedUser })
            if (typeof data == "number") {
                console.log(data)
                return;
            }
            handleCancel();
        }
        connectUserToCard();
    }

    const SelectQR = () => setShowQRScanner(true)

    const QRScanner = () => {

        //const stream = video.srcObject;
        //const track = stream.getVideoTracks()[0];

        //console.log(track.getCapabilities());
        //console.log(track.getSettings());

       /* await track.applyConstraints({
            advanced: [
                {
                    focusMode: "continuous"
                }
            ]
        });
        */
        return (
            <>
                <QRScanner2 //QrReader
                    onScan={(result) => {
                        
                        setCardFilter(result);
                        
                    }}
                    
                />
            </>
        );
    };

    /*
    style={{ width: '100%' }}
                    constraints={{
                        facingMode: 'environment',
                        width: { ideal: 3840 },
                        height: { ideal: 2160 }
                    }}

                    scanDelay={300}
    */

    return (
        <>
        <Modal footer={null} width={'635px'} minHeight={'300px'} onCancel={handleCancel} cancelText={t('page.acceditormodal.close')} open>
            <Flex style={{justifyContent:"space-around", flexWrap:"nowrap", flexDirection:"row"}}>
                <List header={<p>{t('page.newcard.modal.title')}</p>} footer={<div></div>}>
                    {getItems() }
                </List>
                </Flex>
                <Input placeholder={t('page.newcard.modal.title')} value={cardFilter} style={{ marginBottom: "20px" }} onChange={(e) => { setCardFilter(e.target.value) }}></Input>
                <MobileView>
                    {QRScanner() /*showQRScanner && */} 
                    
                </MobileView>
            <Flex style={{ justifyContent: "center", flexDirection: "row", flexWrap: "wrap" }}><Button onClick={connectSelectedCard}>{t('page.newcard.modal.addnew')}</Button></Flex>
        </Modal>
            
        </>
    )
}

export default NewCardModal
